"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportJobHistoryStatusEnum = void 0;
var ImportJobHistoryStatusEnum;
(function (ImportJobHistoryStatusEnum) {
    ImportJobHistoryStatusEnum["PROCESSING"] = "Processing";
    ImportJobHistoryStatusEnum["COMPLETED"] = "Completed";
})(ImportJobHistoryStatusEnum = exports.ImportJobHistoryStatusEnum || (exports.ImportJobHistoryStatusEnum = {}));
